import React from "react";
import { Box, IconButton, Text, Flex, Icon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ReactComponent as RestartIcon } from "@root/assets/icons/restartIcon.svg";

export interface RestartTourButtonProps {
  onClick: () => void;
  position?: {
    bottom?: string;
    right?: string;
    top?: string;
    left?: string;
  };
  /** Override z-index when button must appear above overlays (e.g. drawer z-index 1400) */
  zIndex?: number;
}

export const RestartTourButton: React.FC<RestartTourButtonProps> = ({
  onClick,
  position = { bottom: "24px", right: "24px" },
  zIndex = 999,
}) => {
  const { t } = useTranslation();

  return null;

  return (
    <Box position="fixed" {...position} zIndex={zIndex}>
      <Flex direction="column" align="center" gap={2}>
        <IconButton
          aria-label={t("tourGuide.restartTour")}
          icon={<Icon as={RestartIcon} w="16px" h="20px" color="#18191B" />}
          onClick={onClick}
          isRound
          size="lg"
          bg="#CDD6DC6E"
          color="white"
          _hover={{ bg: "#CDD6DC6E" }}
          boxShadow="0px 4px 12px rgba(0, 0, 0, 0.15)"
        />
        <Text
          fontSize="11px"
          fontWeight="500"
          color="black"
          textAlign="center"
          maxW="80px"
        >
          {t("tourGuide.restartTour")}
        </Text>
      </Flex>
    </Box>
  );
};
